export const BenefitEN = {
	"benefit": {
		"headingLabel": "Manager Benefit",
		"listBenefit": "List Benefit",
		"createBenefit": "Create Benefit",
		"updateBenefit": "Update Benefit"
	},
	"benefitColumns": {
		"name": "Benefit Name",
		"money": "Money/Unit",
		"tax": "Tax",
		"status": "Status"
	},
	"benefitActions": {
		"add": "Add Benefit",
		"update": "Update Benefit"
	},
	"benefitData": {
		"positionDepartment" : "All department",
		"pending": "Non-active",
		"approved": "Active",
		"reject": "Reject",
		"disable": "Disable",
		"true": "Yes",
		"false": "No",
		"day": "Day",
		"month": "Month"
	},
	"benefitLabel": {
		"name": "Benefit name",
		"money": "Money",
		"tax": "Tax",
		"unit": "Unit"
	},
	"placeholderBenefit": {
		"name" : "Name",
		"money" : "Amount",
		"tax" : "Tax",
		"unit" : "Unit",
		"status" : "Status"
	}
}
